import script from "./card-contato.vue?vue&type=script&setup=true&lang=js"
export * from "./card-contato.vue?vue&type=script&setup=true&lang=js"

import "./card-contato.vue?vue&type=style&index=0&id=9b08984a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b08984a"]])

export default __exports__